// @core/api/endpoints/apikey/create_api_key_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyPolicyResponse,
  CreateAPIKeyPolicyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Create API key policy
 * Creates an API key policy for a scope entity (organization, team, department). Configures key limits, TTL, rate limiting, and security requirements.
 */
export async function CreateAPIKeyPolicy(
  data: CreateAPIKeyPolicyRequest,
  options?: RequestOptions
): Promise<APIKeyPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-key-policies`;
  const requestOptions = options;
  return client.post<APIKeyPolicyResponse>(requestPath, data, requestOptions);
}
